<template>
  <div class="card homapt-expandable">
    <img class="card-img-top" v-bind:src="imageUrl" alt="Card image cap">
    <div class="card-body">
      <h5 class="card-title">{{ title }}</h5>
      <p class="card-text">{{ caption }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    image: String,
    caption: String,
    postId: String,
    userId: String
  },
  computed: {
    imageUrl () {
      return 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xsmall/' + this.userId + '/' + this.image
    }
  }
}
</script>

<style scoped>
.card-img-top {
  padding: 1rem;
}

.card {
  border-radius: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/insights/EntryCard.vue